var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-pickr',_vm._b({staticClass:"date-input",attrs:{"config":_vm.config},on:{"blur":function($event){return _vm.$emit("blur", $event)}},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'flat-pickr',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }